
import { Component, Inject, Vue, Watch } from 'vue-property-decorator';
import FormattedGlossName from '@/ui/FormattedGlossName.vue';
import GlossSearchResult from '@/api/graph/GlossSearchResult';
import GlossRepository from '@/api/GlossRepository';
import { BehaviorSubject, Subscription } from 'rxjs';
import { BeforeDestroyAware, CreatedAware } from '@/util/lifecycle';
import { debounceTime, switchMap } from 'rxjs/operators';

@Component({
    components: {
        FormattedGlossName,
    },
})
export default class GlossSearchBar extends Vue implements CreatedAware, BeforeDestroyAware {
    public search = '';
    public hasFocus = false;
    public loading = false;
    public results: GlossSearchResult[] = [];

    @Inject()
    private readonly glossRepository!: GlossRepository;
    private searchSubject = new BehaviorSubject('');
    private searchSubscription = new Subscription();

    public get hasResults(): boolean {
        return this.results.length > 0;
    }

    public created(): void {
        this.searchSubscription = this.searchSubject
            .pipe(
                debounceTime(300),
                switchMap((search) => this.glossRepository.findGlossesByKeyword(100, null, search, true)),
            )
            .subscribe((resource) => {
                this.loading = resource.isLoading;
                if (resource.hasData()) {
                    this.results = resource.data.nodes;
                }
            });
    }

    public beforeDestroy(): void {
        this.searchSubscription.unsubscribe();
    }

    @Watch('search')
    public onSearchChanged(search: string): void {
        this.searchSubject.next(search);
    }

    public onSelectGloss(gloss: GlossSearchResult): void {
        this.search = gloss.name;
        this.$emit('select', gloss);
    }
}
